import { Button } from "components/Button";
import styled from "styled-components";
import "./DownloadContainer.css";
import { useContext } from "react";
import { CalculatorContext } from "App";

const List = styled.div`
  position: absolute;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 5;
  background-color: #fff;
  top: 0;
  text-align: center;
`;

export const DownloadContainer = () => {
  const context = useContext(CalculatorContext);

  const { translations } = context!;
  return (
    <>
      <List className="download-container">
        <h2>{translations["download-items"]}</h2>
        <Button variant="primary">{translations["get-the-list"]}</Button>
      </List>
    </>
  );
};
